import request from '@/utils/request'


// 获取图片上传限制大小
export function getUploadImgSize() {
  return request({
    url: '/api/free/sysconfig/getConfigValue/' + 'upload.img.size',
    method: 'get',
  })
}
